export default __webpack_public_path__ + "static/media/Background_00197.45deead1.png";